'use strict';

const root = "_root_jbbqu_1";
const styles = {
	root: root
};

exports.styles = styles;
//# sourceMappingURL=Symbol.module-CBwbHbxh.js.map
